import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Home from './pages/Home';
import About from './pages/About';
import OurHomes from './pages/OurHomes';
import OurTeam from './pages/OurTeam';
import TherapyServices from './pages/TherapyServices';
import JoinOurTeam from './pages/JoinOurTeam';
import HearFromOurPeople from './pages/HearFromOurPeople';
import OurValues from './pages/OurValues';
import OurTips from './pages/OurTips';
import OurBenefits from './pages/OurBenefits';
import Faq from './pages/Faq';
import EqualOpportunities from './pages/EqualOpportunities';
import CookieNotice from './pages/CookieNotice';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsConditions from './pages/TermsConditions';
import TermsOfUse from './pages/TermsOfUse';
import YoungPerson from './pages/YoungPerson';
import TherapyAssessments from './pages/TherapyAssessments';
import TherapyInterventions from './pages/TherapyInterventions';
import LifestyleMedicine from './pages/LifestyleMedicine';
import CareHomes from './pages/CareHomes';
import ContactUsPage from './pages/ContactUsPage';

function ScrollToHash() {
  const location = useLocation();

  useEffect(() => {
    if (!location.hash) return;

    const id = location.hash.replace('#', '');
    // Wait for route transition render
    window.requestAnimationFrame(() => {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }, [location.pathname, location.hash]);

  return null;
}

function App() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);

  return (
    <Router>
      <ScrollToHash />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/our-homes" element={<OurHomes />} />
        <Route path="/our-team" element={<OurTeam />} />
        <Route path="/therapy-services" element={<TherapyServices />} />
        <Route path="/therapy-services/assessments" element={<TherapyAssessments />} />
        <Route path="/therapy-services/interventions" element={<TherapyInterventions />} />
        <Route path="/therapy-services/lifestyle-medicine" element={<LifestyleMedicine />} />
        <Route path="/join-our-team" element={<JoinOurTeam />} />
        <Route path="/hear-from-our-people" element={<HearFromOurPeople />} />
        <Route path="/our-values" element={<OurValues />} />
        <Route path="/our-tips" element={<OurTips />} />
        <Route path="/our-benefits" element={<OurBenefits />} />
        <Route path="/faqs" element={<Faq />} />
        <Route path="/legal/faqs" element={<Faq />} />
        <Route path="/equal-opportunities" element={<EqualOpportunities />} />
        <Route path="/legal/equal-opportunities" element={<EqualOpportunities />} />
        <Route path="/cookie-notice" element={<CookieNotice />} />
        <Route path="/legal/cookie-notice" element={<CookieNotice />} />
        <Route path="/cookies" element={<CookieNotice />} />
        <Route path="/cookies/" element={<CookieNotice />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/legal/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/privacy/" element={<PrivacyPolicy />} />
        <Route path="/terms-conditions" element={<TermsConditions />} />
        <Route path="/legal/terms-conditions" element={<TermsConditions />} />
        <Route path="/terms-of-use" element={<TermsOfUse />} />
        <Route path="/terms-of-use/" element={<TermsOfUse />} />
        <Route path="/young-person" element={<YoungPerson />} />
        <Route path="/contact-us" element={<ContactUsPage />} />
        <Route path="/contact" element={<ContactUsPage />} />
        <Route path="/care-homes" element={<CareHomes />} />
      </Routes>
    </Router>
  );
}

export default App;
